module.exports = __webpack_public_path__ + "img/MS.b414e726.png";